import { z } from 'zod';
import { ReferralStatus } from '../enums';

export const RecommendationHistoryCycle = z.object({
  id: z.string().uuid(),
  code: z.string(),
  label: z.string(),
  endsOn: z.string(),
});
export type RecommendationHistoryCycle = z.infer<typeof RecommendationHistoryCycle>;

export const RecommendationHistoryRow = z.object({
  id: z.string().uuid(),
  referenceNumber: z.string().nullable(),
  status: ReferralStatus,
  familyLastName: z.string(),
  childNames: z.array(z.string()),
  cycle: RecommendationHistoryCycle.nullable(),
  approvedAt: z.string(),
  usedAt: z.string().nullable(),
  expiresOn: z.string().nullable(),
  active: z.boolean(),
  expired: z.boolean(),
});
export type RecommendationHistoryRow = z.infer<typeof RecommendationHistoryRow>;

export const HistoryTrustee = z.object({
  id: z.string().uuid(),
  displayName: z.string(),
  email: z.string(),
});
export type HistoryTrustee = z.infer<typeof HistoryTrustee>;

export const StaffRecommendationHistoryRow = RecommendationHistoryRow.extend({
  trustee: HistoryTrustee,
  householdId: z.string().uuid().nullable(),
});
export type StaffRecommendationHistoryRow = z.infer<typeof StaffRecommendationHistoryRow>;

export const TrusteeRecommendationSummary = z.object({
  trustee: HistoryTrustee,
  total: z.number().int(),
  active: z.number().int(),
  expired: z.number().int(),
  lastUsedAt: z.string().nullable(),
});
export type TrusteeRecommendationSummary = z.infer<typeof TrusteeRecommendationSummary>;

export const MyRecommendationHistory = z.object({
  rows: z.array(RecommendationHistoryRow),
});
export type MyRecommendationHistory = z.infer<typeof MyRecommendationHistory>;

export const RecommendationHistory = z.object({
  limit: z.number().int(),
  rows: z.array(StaffRecommendationHistoryRow),
  trustees: z.array(TrusteeRecommendationSummary),
});
export type RecommendationHistory = z.infer<typeof RecommendationHistory>;
